var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assets-root"},[_c('pui-file-assets',{attrs:{"forcedSelectedFiles":_vm.selectedFiles},on:{"openSelectionDialog":_vm.openSelectionDialog}}),_c('pui-file-selection-dialog',{ref:"fileSelectionDialog",on:{"resetSelectedFiles":_vm.onResetSelectedFiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }